import '../App.css';
import axios from 'axios';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from 'react';
import QRCode from "react-qr-code";
import Header from '../Header';
import DeviceHeader from './DeviceHeader';
import V2Card from '../V2Card';
import V2Warning from './V2Warning';

function DeviceHowToConnect({ menu }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [token, setToken] = useState(null);
    const [link, setLink] = useState(null);

    function generateToken() {
        axios.post(
            process.env.REACT_APP_API_HOST + '/device/generate_token/',
            {
                device_id: searchParams.get('device_id'),
            }
        ).then(
            (response) => {
                const token = response.data.token;
                setToken(token);
                setLink(
                    `https://${window.location.host}/screen/login/?token=${token}`
                );
            }
        )
    }

    useEffect(
        () => {
            generateToken();
        },
        [],
    )

    return (
        <div align='center'>
            {menu}
            <DeviceHeader title='How to Connect' />
            <V2Card>
                <V2Card>
                    <div className='mk2-subtitle'>
                        Scan this code with your tablet:
                    </div>
                    <div style={{ marginLeft: '2em', marginTop: '1em' }}>
                        {
                            link &&
                            <QRCode
                                // size={256}
                                style={{
                                    height: "auto",
                                    width: '18em',
                                    backgroundColor: 'white',
                                    padding: '1em',
                                }}
                                value={link}
                                viewBox={`0 0 256 256`}
                            />
                        }
                        {
                            !link &&
                            <ProgressSpinner />
                        }
                    </div>
                </V2Card>
                <V2Card>
                    <V2Warning
                        title='If you cannot scan the QR code, please see the steps below:'
                    />
                    <div
                        align='left'
                    >
                        <div>
                            On your tablet, navigate to:
                            <div style={{ marginTop: '0.5em' }}>
                                <b>
                                    {`https://${window.location.host}/screen/login/`}
                                </b>
                            </div>
                            <div style={{ marginTop: '1em' }}>
                                Use this token on your tablet:
                            </div>
                            <div style={{ marginTop: '0.5em' }}>
                                <b>
                                    <h3>
                                        {
                                            token &&
                                            <div style={{ letterSpacing: '0.2em' }}>
                                                {token}
                                            </div>
                                        }
                                        {
                                            !token &&
                                            <div>
                                                generating token..
                                            </div>
                                        }
                                    </h3>
                                </b>
                            </div>
                        </div>
                    </div>
                </V2Card>
            </V2Card>
        </div >
    );
}

export default DeviceHowToConnect;